var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg63(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3047 33.418C13.418 33.2942 13.5557 33.1952 13.709 33.127C13.8622 33.0585 14.0275 33.0213 14.1953 33.0176H42.1875C42.3059 33.0189 42.4213 33.0549 42.5195 33.1211C42.5931 33.1703 42.6553 33.2348 42.7017 33.3102C42.7482 33.3856 42.7778 33.4701 42.7885 33.558C42.7993 33.6459 42.7909 33.7351 42.764 33.8194C42.7372 33.9038 42.6924 33.9814 42.6328 34.0469L36.6953 40.625C36.5812 40.7481 36.4436 40.8471 36.2907 40.9162C36.1377 40.9853 35.9725 41.0231 35.8047 41.0273H7.79881C7.68055 41.0251 7.56539 40.9892 7.46678 40.9238C7.36804 40.8583 7.29065 40.7653 7.24412 40.6562C7.19662 40.5477 7.18168 40.4278 7.20109 40.3109C7.22051 40.1941 7.27346 40.0854 7.3535 39.998L13.3047 33.418ZM42.6562 27.9492C42.7352 28.0372 42.7874 28.1458 42.8068 28.2624C42.8262 28.379 42.8119 28.4987 42.7656 28.6074C42.7188 28.7162 42.6416 28.8092 42.5432 28.875C42.4447 28.9409 42.3293 28.9768 42.2109 28.9785L14.2129 29C14.0449 28.9982 13.8791 28.9609 13.7265 28.8906C13.5732 28.8224 13.4356 28.7233 13.3222 28.5996L7.34373 22.043C7.26403 21.9554 7.21129 21.8467 7.19183 21.7299C7.17238 21.6131 7.18704 21.4932 7.23405 21.3845C7.28106 21.2759 7.35844 21.1831 7.45688 21.1173C7.55532 21.0515 7.67066 21.0155 7.78904 21.0137L35.7871 20.9922C35.9551 20.994 36.1208 21.0313 36.2734 21.1016C36.4267 21.1698 36.5643 21.2689 36.6777 21.3926L42.6562 27.9492ZM13.3047 9.375C13.4188 9.25191 13.5563 9.15289 13.7093 9.08379C13.8623 9.01469 14.0275 8.97691 14.1953 8.97266L42.2012 8.98438C42.3192 8.98638 42.4343 9.02223 42.5326 9.08766C42.6309 9.1531 42.7084 9.24536 42.7558 9.35352C42.8033 9.46237 42.8182 9.58263 42.7987 9.69976C42.7793 9.8169 42.7265 9.92592 42.6465 10.0137L36.6953 16.582C36.5819 16.7058 36.4443 16.8048 36.291 16.873C36.1378 16.9415 35.9724 16.9787 35.8047 16.9824H7.79881C7.68072 16.9804 7.56569 16.9446 7.46737 16.8791C7.36905 16.8137 7.29157 16.7214 7.24412 16.6133C7.19671 16.5044 7.1818 16.3842 7.20121 16.267C7.22062 16.1499 7.27351 16.0409 7.3535 15.9531L13.3047 9.375Z",
    fill: "url(#paint0_linear_2460_2713)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2460_2713",
    x1: 8.25975,
    y1: 41.7402,
    x2: 41.7304,
    y2: 8.26953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8A53F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#6377D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#24B0A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#00D18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D18C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg63);
export default __webpack_public_path__ + "static/media/63.3e1c24bcec5720cc52d272dcb6f308e4.svg";
export { ForwardRef as ReactComponent };